module.exports = __webpack_public_path__ + "static/christmas_candle_blow_1937.7c3fc5e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project3/christmas_candle_blow_1937.jpg
// module id = 502
// module chunks = 142966368958528